// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__25Fmk","topBottomGutter":"Layout_topBottomGutter__2XoKE"};